import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { LABEL_ENTITY_VALUE, LabelMultiSelect } from '../../../../Label'
import { CHAT_FORM_FIELD_NAME_LABELS } from '../../ChatForm.constants'

function LabelField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      Select={LabelMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Chat.LabelsPlaceholderKey'),
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      entity={LABEL_ENTITY_VALUE.chat}
      fieldComponentProps={{
        label: `${t('Chat.LabelsLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={CHAT_FORM_FIELD_NAME_LABELS}
    />
  )
}

export default LabelField
